  window.wpcWildlifeAudio = window.wpcWildlifeAudio || null;
  window.wpcWildlifePlayingButton = window.wpcWildlifePlayingButton || null;
  window.wpcWildlifeInsightIndex = window.wpcWildlifeInsightIndex || 0;
  window.wpcWildlifeInsights = window.wpcWildlifeInsights || [];
  const WPC_RECENTLY_HEARD_CACHE_KEY_V2 = 'wpcWildlifeRecentlyHeardV2';

  async function loadWpcWildlife() {
    const DATA_URL = 'https://wpc-wildlife-live.jbmanning5.workers.dev/dashboard.json';

    const hearingContainer = document.getElementById('wpc-hearing-now-v2');
    const wildlifeStatus = document.getElementById('wpc-wildlife-status-v2');
    const updated = document.getElementById('wpc-updated-at-v2');

    const weatherContainer = document.getElementById('wpc-weather-now-v2');
    const weatherStatus = document.getElementById('wpc-weather-status-v2');

    const todayTitle = document.getElementById('wpc-today-title-v2');
    const todaySummary = document.getElementById('wpc-today-summary-v2');
    const newReturning = document.getElementById('wpc-new-returning-v2');

    const activityContainer = document.getElementById('wpc-activity-matrix-v2');
    const activitySummary = document.getElementById('wpc-activity-summary-v2');

    const insightTitle = document.getElementById('wpc-insight-title-v2');
    const insightText = document.getElementById('wpc-insight-text-v2');
    const insightDetail = document.getElementById('wpc-insight-detail-v2');
    const insightPrev = document.getElementById('wpc-insight-prev-v2');
    const insightNext = document.getElementById('wpc-insight-next-v2');
    const stationPrimary = document.getElementById('wpc-station-primary-v2');
    const stationChecks = document.getElementById('wpc-station-checks-v2');

    if (!hearingContainer || !wildlifeStatus || !updated || !weatherContainer || !weatherStatus) return;

    try {
      const response = await fetch(`${DATA_URL}?t=${Date.now()}`, { cache: 'no-store' });

      if (!response.ok) {
        throw new Error(`Could not load wildlife data. Status: ${response.status} ${response.statusText}`);
      }

      const data = await response.json();

      renderHearingNow(data, hearingContainer, wildlifeStatus);
      renderWeather(data, weatherContainer, weatherStatus);
      renderSummaryCards(data, todayTitle, todaySummary, newReturning);
      renderActivityMatrix(data, activityContainer, activitySummary);
      renderInsights(data, insightTitle, insightText, insightDetail, insightPrev, insightNext);
      renderStationStatus(data, stationPrimary, stationChecks);

      if (data.updatedAt) {
        const date = new Date(data.updatedAt);
        updated.textContent = `Last updated ${date.toLocaleString([], {
          month: 'short',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit'
        })}`;
      } else {
        updated.textContent = '';
      }
    } catch (error) {
      wildlifeStatus.textContent = 'Offline';
      wildlifeStatus.classList.add('is-offline-v2');
      weatherStatus.textContent = 'Offline';
      weatherStatus.classList.add('is-offline-v2');

      hearingContainer.innerHTML = `<div class="wpc-error-v2">Wildlife data could not be loaded right now. ${escapeHtml(error.message)}</div>`;
      weatherContainer.innerHTML = `<div class="wpc-error-v2">Weather data could not be loaded right now.</div>`;

      if (activityContainer) {
        activityContainer.innerHTML = `<div class="wpc-error-v2">Daily activity could not be loaded right now.</div>`;
      }

      renderStationStatus({}, stationPrimary, stationChecks);

      console.error(error);
    }
  }

  function renderHearingNow(data, container, status) {
    const freshness = getDashboardFreshness(data);
    const isFresh = freshness?.state === 'current';
    const species = getRecentUniqueSpecies(data, 6, { requireClip: true, cacheKey: WPC_RECENTLY_HEARD_CACHE_KEY_V2 });

    status.classList.remove('is-offline-v2');
    status.classList.remove('is-delayed-v2');
    status.textContent = isFresh ? (species.length ? 'Updated recently' : 'Quiet right now') : 'Data delayed';
    if (freshness?.state === 'delayed') status.classList.add('is-delayed-v2');
    if (!freshness || freshness.state === 'unavailable') status.classList.add('is-offline-v2');

    if (!species.length) {
      container.innerHTML = freshness?.state === 'current'
        ? '<div class="wpc-loading-v2">The woods are quiet right now. Check back soon.</div>'
        : '<div class="wpc-loading-v2">The listening station has not sent fresh playable detections. Check back once the data feed catches up.</div>';
      return;
    }

    const staleNotice = isFresh ? '' : `<div class="wpc-stale-note-v2">Latest published wildlife data is ${escapeHtml(formatFreshnessAge(freshness))}. Showing the most recent playable clips received by the public feed.</div>`;

    container.innerHTML = species.map(item => {
      const commonName = item.commonName || 'Unknown species';
      const scientificName = item.scientificName || '';
      const clipUrl = item.clipUrl || '';
      const heardLabel = formatDetectionLabel(item, isFresh ? 'Heard' : 'Last received');

      const thumb = item.thumbnailDataUri
        ? `<img src="${item.thumbnailDataUri}" alt="${escapeHtml(commonName)}" loading="lazy">`
        : `<div class="wpc-species-thumb-placeholder-v2">♪</div>`;

      const playButton = clipUrl
        ? `<button class="wpc-play-button-v2" type="button" data-clip-url="${escapeHtml(clipUrl)}" aria-label="Play ${escapeHtml(commonName)} sound clip">▶</button>`
        : `<div class="wpc-play-button-placeholder-v2" aria-hidden="true"></div>`;

      return `
        <article class="wpc-species-card-v2">
          <div class="wpc-species-thumb-v2">
            ${thumb}
          </div>
          <div>
            <strong>${escapeHtml(commonName)}</strong>
            <em>${escapeHtml(scientificName)}</em>
            <span>${escapeHtml(heardLabel)}</span>
          </div>
          ${playButton}
        </article>
      `;
    }).join('');

    container.innerHTML = staleNotice + container.innerHTML;
  }
  function getRecentUniqueSpecies(data, limit = 6, options = {}) {
    const liveCandidates = [
      data.hearingNow,
      data.recentlyHeard,
      data.recentDetections,
      data.latestDetections,
      data.detections,
      data.todayDetections,
      data.todaySpecies
    ].filter(Array.isArray).flat();
    const cachedCandidates = options.cacheKey ? readRecentlyHeardCache(options.cacheKey) : [];
    const candidates = liveCandidates.concat(cachedCandidates);

    const unique = [];
    const seen = new Set();

    candidates
      .slice()
      .sort((a, b) => getDetectionTime(b) - getDetectionTime(a))
      .forEach(item => {
        const commonName = item.commonName || item.common_name || item.species || '';
        const scientificName = item.scientificName || item.scientific_name || '';
        const key = `${commonName || scientificName}`.trim().toLowerCase();

        if (options.requireClip && !isPlayableUrl(item.clipUrl)) return;
        if (!key || seen.has(key) || unique.length >= limit) return;

        seen.add(key);
        unique.push(item);
      });

    if (options.cacheKey) {
      writeRecentlyHeardCache(options.cacheKey, unique, limit);
    }

    return unique;
  }

  function readRecentlyHeardCache(cacheKey) {
    try {
      const cached = window.localStorage.getItem(cacheKey);
      const items = cached ? JSON.parse(cached) : [];
      return Array.isArray(items) ? items : [];
    } catch (error) {
      return [];
    }
  }

  function writeRecentlyHeardCache(cacheKey, items, limit) {
    try {
      const cacheable = items
        .filter(item => isPlayableUrl(item.clipUrl))
        .slice(0, limit)
        .map(item => ({
          commonName: item.commonName || item.common_name || item.species || '',
          scientificName: item.scientificName || item.scientific_name || '',
          lastHeard: item.lastHeard || item.lastHeardAt || item.last_heard || item.detectedAt || item.time || '',
          lastHeardLabel: item.lastHeardLabel || item.status || '',
          thumbnailDataUri: item.thumbnailDataUri || '',
          clipUrl: item.clipUrl || ''
        }));
      window.localStorage.setItem(cacheKey, JSON.stringify(cacheable));
    } catch (error) {
      // Storage can be disabled; the card still works from the live feed.
    }
  }

  function getDetectionTime(item) {
    const value = item.lastHeardAt
      || item.lastHeard
      || item.last_heard
      || item.last_heard_at
      || item.detectedAt
      || item.detected_at
      || item.timestamp
      || item.time
      || item.date;

    const parsed = value ? new Date(value).getTime() : 0;
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function isPlayableUrl(value) {
    return /^https?:\/\//i.test(String(value || '').trim());
  }

  function getDashboardFreshness(data) {
    return getFreshness(data.updatedAt || data.generatedAt || data.lastUpdatedAt);
  }

  function getWeatherFreshness(data) {
    const weather = data.weather || {};
    return getFreshness(
      weather.observedAt
        || weather.updatedAt
        || weather.timestamp
        || weather.time
        || weather.updatedAtRaw
        || data.updatedAt
    );
  }

  function getFreshness(value) {
    const timestamp = parseTimestamp(value);
    if (!timestamp) return null;
    const minutes = Math.max(0, (Date.now() - timestamp) / 60000);
    return {
      timestamp,
      minutes,
      state: minutes <= 15 ? 'current' : minutes <= 60 ? 'delayed' : 'unavailable'
    };
  }

  function parseTimestamp(value) {
    if (!value) return 0;
    if (typeof value === 'number') return Number.isFinite(value) ? value : 0;

    const raw = String(value).trim();
    const weatherMatch = raw.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2,4})\s+(\d{1,2}):(\d{2})$/);
    if (weatherMatch) {
      const [, day, month, year, hour, minute] = weatherMatch;
      const fullYear = Number(year) < 100 ? 2000 + Number(year) : Number(year);
      const parsed = new Date(fullYear, Number(month) - 1, Number(day), Number(hour), Number(minute)).getTime();
      return Number.isFinite(parsed) ? parsed : 0;
    }

    const direct = new Date(raw).getTime();
    if (Number.isFinite(direct)) return direct;

    return 0;
  }

  function formatFreshnessAge(freshness) {
    if (!freshness) return 'not currently available';
    if (freshness.minutes < 1) return 'less than a minute old';
    if (freshness.minutes < 90) return `${Math.round(freshness.minutes)} minutes old`;
    return `${Math.round(freshness.minutes / 60)} hours old`;
  }

  function formatDetectionLabel(item, prefix = 'Heard') {
    const timestamp = getDetectionTime(item);
    if (timestamp) {
      return `${prefix} at ${new Date(timestamp).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}`;
    }

    return item.lastHeardLabel || item.status || 'Heard recently';
  }

  function renderActivityMatrix(data, container, summaryElement) {
    if (!container) return;

    const matrix = data.activityMatrix || {};
    const hours = Array.isArray(matrix.hours) && matrix.hours.length ? matrix.hours : makeDefaultHours();
    const rows = Array.isArray(matrix.species) ? matrix.species : [];
    const maxCount = Math.max(1, Number(matrix.maxCount || 1));

    if (!rows.length) {
      container.innerHTML = '<div class="wpc-loading-v2">No activity matrix data is available yet.</div>';
      if (summaryElement) {
        summaryElement.textContent = 'No hourly activity has been logged yet today.';
      }
      return;
    }

    const totalDetections = rows.reduce((sum, row) => sum + Number(row.totalDetections || 0), 0);

    if (summaryElement) {
      summaryElement.textContent = `${rows.length} active species shown today, with ${totalDetections.toLocaleString()} detections across the matrix. Swipe or scroll sideways to explore all 24 hours.`;
    }

    const header = `
      <div class="wpc-activity-row-v2">
        <div class="wpc-activity-corner-v2">Species</div>
        <div class="wpc-activity-total-header-v2">Total</div>
        ${hours.map(hour => `<div class="wpc-activity-hour-v2">${escapeHtml(hour)}</div>`).join('')}
      </div>
    `;

    const body = rows.map(row => {
      const commonName = row.commonName || 'Unknown species';
      const scientificName = row.scientificName || '';
      const counts = Array.isArray(row.hourlyCounts) ? row.hourlyCounts : [];
      const total = Number(row.totalDetections || counts.reduce((a, b) => a + Number(b || 0), 0));

      const thumb = row.thumbnailDataUri
        ? `<img src="${row.thumbnailDataUri}" alt="${escapeHtml(commonName)}" loading="lazy">`
        : `<div class="wpc-activity-species-placeholder-v2">♪</div>`;

      const cells = hours.map((hour, index) => {
        const count = Number(counts[index] || 0);
        const style = count > 0 ? ` style="${getHeatCellStyle(count, maxCount)}"` : '';
        const title = `${commonName}: ${count} detections during ${hour}:00`;
        return `<div class="wpc-activity-cell-v2${count ? '' : ' is-empty-v2'}"${style} title="${escapeHtml(title)}">${count ? count : '&nbsp;'}</div>`;
      }).join('');

      return `
        <div class="wpc-activity-row-v2">
          <div class="wpc-activity-species-v2">
            ${thumb}
            <div>
              <strong>${escapeHtml(commonName)}</strong>
              <em>${escapeHtml(scientificName)}</em>
            </div>
          </div>
          <div class="wpc-activity-total-v2">${total.toLocaleString()}</div>
          ${cells}
        </div>
      `;
    }).join('');

    container.innerHTML = `<div class="wpc-activity-table-v2">${header}${body}</div>`;
  }

  function renderInsights(data, titleElement, textElement, detailElement, prevButton, nextButton) {
    if (!titleElement || !textElement) return;

    const insights = Array.isArray(data.insights) ? data.insights : [];
    window.wpcWildlifeInsights = insights;

    if (!insights.length) {
      titleElement.textContent = 'Listening station notes';
      textElement.textContent = 'Small patterns noticed by the microphones and weather station will appear here.';
      if (detailElement) detailElement.textContent = '';
      return;
    }

    if (window.wpcWildlifeInsightIndex >= insights.length) {
      window.wpcWildlifeInsightIndex = 0;
    }

    updateInsightCard(titleElement, textElement, detailElement);

    if (prevButton && !prevButton.dataset.bound) {
      prevButton.dataset.bound = 'true';
      prevButton.addEventListener('click', () => {
        const total = window.wpcWildlifeInsights.length || 1;
        window.wpcWildlifeInsightIndex = (window.wpcWildlifeInsightIndex - 1 + total) % total;
        updateInsightCard(titleElement, textElement, detailElement);
      });
    }

    if (nextButton && !nextButton.dataset.bound) {
      nextButton.dataset.bound = 'true';
      nextButton.addEventListener('click', () => {
        const total = window.wpcWildlifeInsights.length || 1;
        window.wpcWildlifeInsightIndex = (window.wpcWildlifeInsightIndex + 1) % total;
        updateInsightCard(titleElement, textElement, detailElement);
      });
    }
  }

  function updateInsightCard(titleElement, textElement, detailElement) {
    const insights = window.wpcWildlifeInsights || [];
    const insight = insights[window.wpcWildlifeInsightIndex];

    if (!insight) return;

    const category = insight.category ? `${insight.category}: ` : '';

    titleElement.textContent = insight.title || 'Wildlife note';
    textElement.textContent = insight.text || '';

    if (detailElement) {
      const confidence = insight.confidence ? `Confidence: ${insight.confidence}` : '';
      const detail = insight.detail || '';
      detailElement.textContent = [category + detail, confidence].filter(Boolean).join(' · ');
    }
  }

  function getHeatCellStyle(count, maxCount) {
    const raw = Math.max(0, Math.min(1, Number(count) / Math.max(1, Number(maxCount))));
    const softened = Math.sqrt(raw);

    const lightness = 93 - softened * 45;
    const saturation = 36 + softened * 20;
    const hue = 176 + softened * 22;

    const textColor = softened > 0.58 ? 'rgba(255,255,255,0.94)' : 'rgba(28,48,40,0.78)';

    return `background: hsl(${hue} ${saturation}% ${lightness}%); color: ${textColor};`;
  }

  function makeDefaultHours() {
    return Array.from({ length: 24 }, (_, index) => String(index).padStart(2, '0'));
  }

  function handleWpcAudioClick(event) {
    const button = event.target.closest('.wpc-play-button-v2');
    if (!button) return;

    const clipUrl = button.getAttribute('data-clip-url');
    if (!clipUrl) return;

    event.preventDefault();

    if (
      window.wpcWildlifeAudio &&
      window.wpcWildlifePlayingButton === button &&
      !window.wpcWildlifeAudio.paused
    ) {
      window.wpcWildlifeAudio.pause();
      resetWpcPlayButton(button);
      window.wpcWildlifePlayingButton = null;
      return;
    }

    if (window.wpcWildlifeAudio) {
      window.wpcWildlifeAudio.pause();
    }

    if (window.wpcWildlifePlayingButton) {
      resetWpcPlayButton(window.wpcWildlifePlayingButton);
    }

    const audio = new Audio(clipUrl);
    window.wpcWildlifeAudio = audio;
    window.wpcWildlifePlayingButton = button;

    button.classList.add('is-loading-v2');
    button.textContent = '…';

    audio.addEventListener('playing', () => {
      button.classList.remove('is-loading-v2');
      button.classList.add('is-playing-v2');
      button.textContent = '❚❚';
    });

    audio.addEventListener('ended', () => {
      resetWpcPlayButton(button);
      window.wpcWildlifePlayingButton = null;
    });

    audio.addEventListener('pause', () => {
      resetWpcPlayButton(button);
    });

    audio.addEventListener('error', () => {
      resetWpcPlayButton(button);
      button.textContent = '!';
      setTimeout(() => resetWpcPlayButton(button), 1200);
    });

    audio.play().catch(() => {
      resetWpcPlayButton(button);
    });
  }

  function resetWpcPlayButton(button) {
    if (!button) return;
    button.classList.remove('is-playing-v2');
    button.classList.remove('is-loading-v2');
    button.textContent = '▶';
  }

  function renderWeather(data, container, status) {
    const weather = data.weather;
    const freshness = getWeatherFreshness(data);
    const isFresh = freshness?.state === 'current';

    status.classList.remove('is-offline-v2');
    status.classList.remove('is-delayed-v2');

    if (!weather) {
      status.textContent = 'No data';
      container.innerHTML = '<div class="wpc-loading-v2">Weather station data is not available yet.</div>';
      return;
    }

    status.textContent = isFresh ? 'Live station' : 'Data delayed';
    if (freshness?.state === 'delayed') status.classList.add('is-delayed-v2');
    if (!freshness || freshness.state === 'unavailable') status.classList.add('is-offline-v2');

    const temp = formatNumber(weather.temperatureF, 1);
    const humidity = formatNumber(weather.humidity, 0);
    const dewPoint = formatNumber(weather.dewPointF, 1);
    const wind = formatNumber(weather.windMph, 1);
    const gust = formatNumber(weather.windGustMph, 1);
    const rainToday = formatNumber(weather.rainTodayIn, 2);
    const pressure = formatNumber(weather.pressureInHg, 2);
    const moonMetric = getMoonMetric(weather);
    const trends = weather.trends || {};
    const tempTrend = getTrendIndicator(trends.temperatureF);
    const humidityTrend = getTrendIndicator(trends.humidity);
    const dewPointTrend = getTrendIndicator(trends.dewPointF);
    const pressureTrend = getTrendIndicator(trends.pressureInHg);
    const windDirection = getWindDirectionIndicator(
      trends.windDirectionDegrees ?? weather.windBearingDegrees
    );
    const feelsLike = formatNumber(
      calculateFeelsLike(weather.temperatureF, weather.humidity, weather.windMph),
      1
    );
    const weatherVisual = getWeatherVisual(weather);

    container.innerHTML = `
<div class="wpc-weather-hero-v2">
  <div class="wpc-weather-icon-wrap-v2 ${weatherVisual.className}" aria-hidden="true">
    ${weatherVisual.svg}
  </div>
  <div>
    <div class="wpc-weather-condition-v2">${escapeHtml(weatherVisual.label)}</div>
    <div class="wpc-weather-temp-v2">${temp}°F</div>
  </div>
</div>
      <p class="wpc-weather-subtitle-v2">
        ${isFresh ? `Feels like ${feelsLike}°F at the listening station.` : `Last weather update is ${escapeHtml(formatFreshnessAge(freshness))}. Showing the most recent conditions received by the public feed.`}
      </p>

      <div class="wpc-weather-metrics-v2">
        <div class="wpc-weather-metric-v2">
          <span>Temperature</span>
          <strong>${temp}°F${tempTrend}</strong>
        </div>
        <div class="wpc-weather-metric-v2">
          <span>Feels like</span>
          <strong>${feelsLike}°F</strong>
        </div>
        <div class="wpc-weather-metric-v2">
          <span>Humidity</span>
          <strong>${humidity}%${humidityTrend}</strong>
        </div>
        <div class="wpc-weather-metric-v2">
          <span>Dew point</span>
          <strong>${dewPoint}°F${dewPointTrend}</strong>
        </div>
        <div class="wpc-weather-metric-v2">
          <span>Wind</span>
          <strong>${wind} mph${windDirection}</strong>
        </div>
        <div class="wpc-weather-metric-v2">
          <span>Gust</span>
          <strong>${gust} mph${windDirection}</strong>
        </div>
        <div class="wpc-weather-metric-v2">
          <span>Rain today</span>
          <strong>${rainToday}"</strong>
        </div>
        <div class="wpc-weather-metric-v2">
          <span>Pressure</span>
          <strong>${pressure} inHg${pressureTrend}</strong>
        </div>
        ${moonMetric}
      </div>
    `;
  }

  function renderStationStatus(data, primary, list) {
    if (!primary || !list) return;
    const candidates = [data.hearingNow,data.recentlyHeard,data.recentDetections,data.latestDetections,data.detections,data.todayDetections].filter(Array.isArray).flat();
    const latestDetection = candidates.reduce((latest,item) => Math.max(latest,getDetectionTime(item)),0);
    const wildlifeFreshness = getDashboardFreshness(data);
    const weatherFreshness = getWeatherFreshness(data);
    const detectionFreshness = getFreshness(latestDetection || null);
    const rows = [];
    const add = (label,detail,result) => {if(result)rows.push({label,detail:result.state==='current'?detail:result.state==='delayed'?'Delayed':'Unavailable',...result});};
    add('Microphone feed','Connected · Recent activity',detectionFreshness);
    add('Weather station','Online · Current',weatherFreshness);
    add('Wildlife processing','Active',wildlifeFreshness);
    add('Public data feed','Current',wildlifeFreshness);
    if(detectionFreshness)rows.push({label:'Last wildlife data received',detail:new Date(detectionFreshness.timestamp).toLocaleString([],{month:'short',day:'numeric',hour:'numeric',minute:'2-digit'}),state:detectionFreshness.state});
    if(weatherFreshness)rows.push({label:'Last weather data received',detail:new Date(weatherFreshness.timestamp).toLocaleString([],{month:'short',day:'numeric',hour:'numeric',minute:'2-digit'}),state:weatherFreshness.state});
    const operational=rows.length&&rows.every(row=>row.state==='current');
    const delayed=rows.some(row=>row.state==='delayed');
    primary.className=`wpc-station-primary-v2 ${operational?'is-current-v2':delayed?'is-delayed-v2':'is-unavailable-v2'}`;
    primary.textContent=operational?'✓ All systems operational':delayed?'! Some station data is delayed':'Station data is currently unavailable';
    list.replaceChildren(...rows.map(row=>{const item=document.createElement('li');item.className=`is-${row.state}-v2`;const label=document.createElement('span');label.textContent=row.label;const value=document.createElement('strong');value.textContent=row.detail;item.append(label,value);return item;}));
  }

  function renderSummaryCards(data, todayTitle, todaySummary, newReturning) {
    if (data.todaySummary && todayTitle && todaySummary) {
      const speciesCount = Number(data.todaySummary.totalSpecies || 0);
      const detectionCount = Number(data.todaySummary.totalDetections || 0);

      if (speciesCount > 0 || detectionCount > 0) {
        todayTitle.textContent = `${speciesCount} species heard today`;
        todaySummary.textContent = `${detectionCount} total detections have been logged by the listening station today.`;
      }
    }

    if (newReturning) {
      const newToday = Array.isArray(data.newToday) ? data.newToday : [];
      const returningToday = Array.isArray(data.returningToday) ? data.returningToday : [];

      if (newToday.length || returningToday.length) {
        const newText = newToday.length ? `New or newly active: ${newToday.join(', ')}.` : '';
        const returningText = returningToday.length ? `Returning regulars: ${returningToday.join(', ')}.` : '';
        newReturning.textContent = `${newText} ${returningText}`.trim();
      }
    }
  }
  function getWeatherVisual(weather) {
    const conditionText = getWeatherConditionText(weather);
    const condition = classifyWeatherCondition(weather, conditionText);
    const isNight = isWeatherNight(weather);

    if (condition === 'stormy') {
      return {
        label: getWeatherVisualLabel(conditionText, condition, 'Stormy'),
        className: 'is-stormy-v2',
        svg: weatherSvgStormy()
      };
    }

    if (condition === 'rainy') {
      return {
        label: getWeatherVisualLabel(conditionText, condition, 'Rainy'),
        className: 'is-rainy-v2',
        svg: weatherSvgRainy()
      };
    }

    if (condition === 'foggy') {
      return {
        label: getWeatherVisualLabel(conditionText, condition, 'Foggy'),
        className: 'is-foggy-v2',
        svg: weatherSvgFoggy()
      };
    }

    if (condition === 'windy') {
      return {
        label: getWeatherVisualLabel(conditionText, condition, 'Windy'),
        className: 'is-windy-v2',
        svg: weatherSvgWindy()
      };
    }

    if (condition === 'cloudy') {
      return {
        label: getWeatherVisualLabel(conditionText, condition, 'Cloudy'),
        className: 'is-cloudy-v2',
        svg: weatherSvgCloudy()
      };
    }

    return {
      label: conditionText || (isNight ? 'Clear night' : 'Clear'),
      className: isNight ? 'is-night-v2' : 'is-clear-v2',
      svg: isNight ? weatherSvgClearNight() : weatherSvgClearDay()
    };
  }

  function classifyWeatherCondition(weather, conditionText) {
    const normalized = conditionText.toLowerCase();
    const conditionCode = String(weather.conditionCode || weather.conditionCategory || weather.conditionType || '').toLowerCase();
    const sourceCondition = `${normalized} ${conditionCode}`;
    const windMph = Number(weather.windMph);
    const gustMph = Number(weather.windGustMph);
    const rainRate = firstFiniteNumber(weather.rainRateInPerHr, weather.rainRateInHr, weather.rainRateIn, weather.precipRateInPerHr, weather.precipRateInHr);
    const hourlyRain = firstFiniteNumber(weather.rainHourIn, weather.rainLastHourIn, weather.precipHourIn);
    const cloudCover = firstFiniteNumber(weather.cloudCover, weather.cloudCoverPercent, weather.cloudCoverPct);
    const visibility = Number(weather.visibilityMiles || weather.visibilityMi);

    if (weather.isStormy === true || /(thunder|lightning|storm|squall)/.test(sourceCondition) || Number(weather.lightningStrikes) > 0) {
      return 'stormy';
    }

    if (weather.isRaining === true || /(rain|shower|drizzle|sprinkle|precip)/.test(sourceCondition) || rainRate > 0 || hourlyRain > 0) {
      return 'rainy';
    }

    if (
      weather.isFoggy === true
      || /(fog|mist)/.test(sourceCondition)
      || (Number.isFinite(visibility) && visibility <= 2)
    ) {
      return 'foggy';
    }

    if (weather.isWindy === true || /(wind|breezy|gust)/.test(sourceCondition) || windMph >= 15 || gustMph >= 25) {
      return 'windy';
    }

    if (weather.isCloudy === true || /(cloud|overcast|partly|mostly)/.test(sourceCondition) || cloudCover >= 25) {
      return 'cloudy';
    }

    return isNightNow() ? 'night' : 'clear';
  }
  function isNightNow() {
    const hour = new Date().getHours();
      return hour < 6 || hour >= 20;
}
  function getWeatherConditionText(weather) {
    const value = weather.condition
      || weather.conditionLabel
      || weather.conditionDisplay
      || weather.conditions
      || weather.conditionText
      || weather.weather
      || weather.summary
      || weather.description
      || '';

    return titleCaseWeather(String(value).trim());
  }

  function getWeatherVisualLabel(conditionText, condition, fallback) {
    if (!conditionText) return fallback;
    return classifyWeatherCondition({}, conditionText) === condition ? conditionText : fallback;
  }

  function firstFiniteNumber(...values) {
    for (const value of values) {
      const number = Number(value);
      if (Number.isFinite(number)) return number;
    }
    return NaN;
  }

  function titleCaseWeather(value) {
    return value.replace(/\w\S*/g, (word) => (
      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    ));
  }

  function isWeatherNight(weather) {
    if (typeof weather.isDay === 'boolean') return !weather.isDay;
    if (typeof weather.isNight === 'boolean') return weather.isNight;

    const timestamp = weather.observedAt || weather.updatedAt || weather.timestamp || weather.time;
    const date = timestamp ? new Date(timestamp) : new Date();
    const hour = Number.isNaN(date.getTime()) ? new Date().getHours() : date.getHours();

    return hour < 6 || hour >= 20;
  }

  function getTrendIndicator(trend) {
    const normalized = String(trend || '').toLowerCase();

    if (normalized === 'up') {
      return '<span class="wpc-weather-trend-v2 is-up-v2" aria-label="Trending up">↑</span>';
    }

    if (normalized === 'down') {
      return '<span class="wpc-weather-trend-v2 is-down-v2" aria-label="Trending down">↓</span>';
    }

    if (normalized === 'steady') {
      return '<span class="wpc-weather-trend-v2 is-steady-v2" aria-label="Steady">–</span>';
    }

    return '';
  }

  function getWindDirectionIndicator(degrees) {
    const bearing = Number(degrees);

    if (!Number.isFinite(bearing)) return '';

    const normalized = ((bearing % 360) + 360) % 360;
    return `<span class="wpc-weather-wind-arrow-v2" style="--wind-bearing: ${normalized}deg;" aria-label="Wind bearing ${Math.round(normalized)} degrees">↑</span>`;
  }

  function getMoonMetric(weather) {
    const phaseLabel = String(weather.moonPhaseLabel || '').trim();
    const illumination = Number(weather.moonIllumination);
    const hasIllumination = Number.isFinite(illumination) && illumination > 0;

    if (!phaseLabel && !hasIllumination) return '';

    const illuminationPercent = hasIllumination
      ? Math.round(illumination <= 1 ? illumination * 100 : illumination)
      : null;
    const moonValue = [
      phaseLabel,
      illuminationPercent !== null ? `${illuminationPercent}%` : ''
    ].filter(Boolean).join(' · ');

    return `
        <div class="wpc-weather-metric-v2">
          <span>Moon</span>
          <strong>${escapeHtml(moonValue)}</strong>
        </div>`;
  }

  function weatherSvgClearDay() {
    return `
      <svg viewBox="0 0 96 96" role="img" focusable="false">
        <circle class="wpc-sun-soft-v2" cx="48" cy="48" r="31"></circle>
        <circle class="wpc-sun-core-v2" cx="48" cy="48" r="24"></circle>
        <path class="wpc-ground-v2" d="M10 77c12-7 23-10 35-9 14 1 25 8 41 5v14H10z"></path>
      </svg>`;
  }

  function weatherSvgClearNight() {
    return `
      <svg viewBox="0 0 96 96" role="img" focusable="false">
        <circle class="wpc-star-v2" cx="72" cy="17" r="2.5"></circle>
        <circle class="wpc-star-v2" cx="82" cy="34" r="1.8"></circle>
        <circle class="wpc-star-v2" cx="24" cy="23" r="2"></circle>
        <path class="wpc-moon-soft-v2" d="M63 70c-16 0-29-13-29-29 0-12 7-22 17-27-3 15 8 30 24 33-3 13-7 20-12 23z"></path>
        <path class="wpc-moon-v2" d="M60 67c-14-1-25-12-25-26 0-10 6-20 15-24-2 15 8 28 23 31-3 10-7 16-13 19z"></path>
        <path class="wpc-ground-v2" d="M8 78c13-6 25-8 37-7 13 2 25 6 43 2v14H8z"></path>
      </svg>`;
  }

  function weatherSvgCloudy() {
    return `
      <svg viewBox="0 0 96 96" role="img" focusable="false">
        <path class="wpc-cloud-v2" d="M14 63c0-9 7-16 17-16 4-12 14-20 27-20 14 0 25 9 29 22 6 2 10 7 10 14 0 9-7 16-17 16H30c-9 0-16-7-16-16z"></path>
        <path class="wpc-ground-v2" d="M7 79c14-7 25-9 37-7 14 2 24 7 45 3v13H7z"></path>
      </svg>`;
  }

  function weatherSvgRainy() {
    return `
      <svg viewBox="0 0 96 96" role="img" focusable="false">
        <path class="wpc-cloud-v2" d="M12 48c0-8 7-15 16-15 4-11 13-18 26-18 14 0 24 8 28 20 7 2 12 8 12 15 0 9-8 16-18 16H28c-9 0-16-8-16-18z"></path>
        <g class="wpc-rain-lines-v2">
          <path d="M29 71l-8 17h9l8-17z"></path>
          <path d="M48 71l-8 17h9l8-17z"></path>
          <path d="M67 71l-8 17h9l8-17z"></path>
        </g>
      </svg>`;
  }

  function weatherSvgStormy() {
    return `
      <svg viewBox="0 0 96 96" role="img" focusable="false">
        <path class="wpc-cloud-v2" d="M10 49c0-9 7-16 17-16 5-12 15-20 28-20 15 0 26 9 30 23 7 2 11 8 11 15 0 10-8 17-19 17H27c-10 0-17-8-17-19z"></path>
        <path class="wpc-lightning-v2" d="M49 62h17L53 85h14L38 98l10-27H35z"></path>
        <g class="wpc-rain-lines-v2">
          <path d="M24 72l-6 14h8l7-14z"></path>
          <path d="M73 72l-6 14h8l7-14z"></path>
        </g>
      </svg>`;
  }

  function weatherSvgWindy() {
    return `
      <svg viewBox="0 0 96 96" role="img" focusable="false">
        <path class="wpc-wind-line-v2" d="M10 75c13-11 17-30 16-55 11 17 12 36 5 58z"></path>
        <path class="wpc-wind-line-v2" d="M30 78c15-13 20-36 18-64 12 20 13 43 4 67z"></path>
        <path class="wpc-wind-line-v2" d="M53 79c13-10 17-29 16-54 11 16 12 36 5 56z"></path>
        <path class="wpc-wind-line-v2" d="M73 80c8-8 11-20 10-37 8 11 8 25 3 38z"></path>
        <path class="wpc-ground-v2" d="M6 78c17-5 32-7 47-5 14 2 25 4 38 0v15H6z"></path>
      </svg>`;
  }

  function weatherSvgFoggy() {
    return `
      <svg viewBox="0 0 96 96" role="img" focusable="false">
        <path class="wpc-tree-v2" d="M15 73h6V50h-6zM11 50l7-20 8 20zM68 74h7V43h-7zM63 43l9-26 10 26z"></path>
        <path class="wpc-tree-v2" d="M35 75h6V56h-6zM31 56l7-18 7 18z"></path>
        <rect class="wpc-fog-band-v2" x="9" y="47" width="78" height="10" rx="5"></rect>
        <rect class="wpc-fog-band-v2" x="17" y="62" width="71" height="9" rx="4.5"></rect>
        <rect class="wpc-fog-band-v2" x="6" y="77" width="74" height="8" rx="4"></rect>
      </svg>`;
  }
  function calculateFeelsLike(tempF, humidity, windMph) {
    const T = Number(tempF);
    const RH = Number(humidity);
    const V = Number(windMph);

    if (!Number.isFinite(T)) return T;

    if (T >= 80 && Number.isFinite(RH)) {
      return -42.379
        + 2.04901523 * T
        + 10.14333127 * RH
        - 0.22475541 * T * RH
        - 0.00683783 * T * T
        - 0.05481717 * RH * RH
        + 0.00122874 * T * T * RH
        + 0.00085282 * T * RH * RH
        - 0.00000199 * T * T * RH * RH;
    }

    if (T <= 50 && Number.isFinite(V) && V > 3) {
      return 35.74
        + 0.6215 * T
        - 35.75 * Math.pow(V, 0.16)
        + 0.4275 * T * Math.pow(V, 0.16);
    }

    return T;
  }

  function formatNumber(value, decimals) {
    const number = Number(value);
    if (!Number.isFinite(number)) return '--';
    return number.toFixed(decimals);
  }

  function escapeHtml(value) {
    return String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  document.removeEventListener('click', handleWpcAudioClick);
  document.addEventListener('click', handleWpcAudioClick);

  loadWpcWildlife();
  setInterval(loadWpcWildlife, 60000);
